// Spawns the PoW miner as an INLINE worker.
//
// Vite's `?worker&inline` bundles the worker (worker.js + its deps) into the
// main bundle as a base64 blob; at runtime `new InlineMiner()` creates the
// worker from a same-origin blob: URL.
//
// Why: the widget is embedded on third-party origins (e.g. example.com),
// but the bundle is served from captcha.qr6.eu. The previous
// `new Worker(new URL("../worker/worker.js", import.meta.url))` resolved to
// `https://captcha.qr6.eu/assets/worker-*.js` — a CROSS-ORIGIN worker, which
// browsers refuse to start (→ no proof-of-work → `insufficient_work`).
// An inline blob worker is same-origin to the host page, so it runs anywhere
// with no cross-origin fetch and no CORS on /assets needed.
import InlineMiner from "./worker.js?worker&inline";

export function spawnMinerWorker() {
  return new InlineMiner();
}
